import { Typography } from '@mui/material';

import { Flex } from 'components/ui/flex';

const fontFamily = 'Inter';

const ProductPreviewV3 = ({
  textColor,
  name,
  quantity,
  imageUrl
}: {
  textColor: string;
  name: string;
  quantity: string;
  imageUrl: string;
}) => {
  return (
    <Flex className="h-12 w-full px-3 py-2">
      <Flex direction="row" justify="between" className="gap-3">
        <Flex direction="row" align="center" className="gap-1">
          <img
            src={imageUrl}
            alt={name}
            style={{
              width: '30px',
              height: '30px'
            }}
          />
          <span
            style={{
              fontSize: '12px',
              fontWeight: 200,
              fontFamily: fontFamily,
              color: textColor
            }}
          >
            {name}
          </span>
        </Flex>
        <Typography
          fontSize={'12px'}
          fontWeight={200}
          color={textColor}
          display="flex"
          alignItems="center"
          fontFamily={fontFamily}
        >
          {quantity}
        </Typography>
      </Flex>
    </Flex>
  );
};

export default ProductPreviewV3;
